
<div class="card-body">
    <form>
        <div class="form-body">
            <h3 class="card-title">Crear o modificar interpretación</h3>
            <hr>
            <div class="row p-t-20">
                <div class="col-md-12">
                    <div class="form-group">
                        <label class="control-label">Subescala</label>
                        <select id="scaleSelector" (change)="changeScale($event.target.value)" class="form-control custom-select m-b-20">
                            <option disabled value="">Seleccione escala...</option>
                            <option value="Cognitiva">Cognitiva</option>
                            <option value="Motora">Motora</option>
                            <option value="No planificada">No planificada</option>
                            <option value="Puntuación total">Puntuación total</option>
                        </select>
                    </div>
                </div>
            </div>
            <div *ngIf="scale" class="row p-t-20">
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">Mínimo</label>
                        <input [(ngModel)]="rank.low" [ngModelOptions]="{standalone:true}" type="number"  class="form-control" placeholder="Mínimo">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">Máximo</label>
                        <input [(ngModel)]="rank.high" [ngModelOptions]="{standalone:true}" type="number"  class="form-control" placeholder="Máximo">
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="form-group">
                        <label class="control-label">Nombre del intervalo</label>
                        <input [(ngModel)]="rank.title" [ngModelOptions]="{standalone:true}" type="text"  class="form-control" placeholder="Nombre del intervalo">
                    </div>
                </div>
                <div class="col-md-12">
                    <h3>Interpretación</h3>
                    <div class="row justify-content-center">
                        <div class="NgxEditor__Wrapper p-20 m-b-40 col-12">
                            <ngx-editor-menu *ngIf="editor" [editor]="editor"> </ngx-editor-menu>
                            <ngx-editor
                              [editor]="editor"
                              [(ngModel)]="html"
                              [placeholder]="'Escriba su texto...'"
                              [ngModelOptions]="{standalone:true}"
                            ></ngx-editor>
                        </div>
                    </div>
                </div>
                <button (click)="addRank()" class="btn btn-rounded waves-effect btn-primary m-b-20">Agregar/reemplazar rango</button>
            </div>
        </div>
        <div *ngIf="selectedScale" class="card">
            <div class="card-body">
                <h4 class="card-title">{{selectedScale.scale}}</h4>
                <table class="table table-bordered table-hover " >
                    <thead>
                        <tr>
                            <th >Nombre</th>
                            <th >Mínimo</th>
                            <th >Máximo</th>
                            <th >Editar/Borrar</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let r of selectedScale.rank; index as i">
                            <td >{{r.title}}</td>
                            <td >{{r.low}}</td>
                            <td >{{r.high}}</td>
                            <td class="footable-visible footable-last-column text-center">
                                <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="editRank(r)" ><i class="fa fa-pencil" aria-hidden="true"></i></button>
                                <button type="button" class="btn btn-sm btn-icon btn-pure btn-outline " (click)="deleteRank(i)" ><i class="fa fa-eraser" ></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="form-actions m-t-20 m-b-20">
            <button type="button" (click)="update()" class="btn btn-rounded waves-effect btn-success">Actualizar escala seleccionada</button>
        </div>
    </form>
</div>